import { AEMErrorMessage } from '../../../models';

export const SnapshotErrorMessage: AEMErrorMessage = {
  action: {
    label: 'View Account Activity Page',
    url: '/acctactvty',
    id: 'viewAccountActivitySnapshotPage'
  },
  component: 'snapshot',
  errorId: [
    {
      errorCode: 'CRD_5002'
    },
    {
      errorCode: 'CRD_2000'
    },
    {
      errorCode: 'CRD_5000'
    },
    {
      errorCode: 'CRD_2000'
    },
    {
      errorCode: 'CRD_1000'
    },
    {
      errorCode: 'CRD_5001'
    },
    {
      errorCode: 'CRD_4000'
    },
    {
      errorCode: '702'
    }
  ],
  featureTitle: 'Your Account Snapshot',
  errorMessageDescription:
    'Sorry, we’re currently unable to display Your Account Snapshot. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
